import { useContext, useEffect, useRef } from "react";
import cx from "classnames";

// Components
import { HeaderFilters } from "./HeaderFilters/HeaderFilters";
import { HeaderFilterTags } from "./HeaderFilterTags/HeaderFilterTags";
import { HeaderRowOne } from "./HeaderRowOne/HeaderRowOne";
import { HeaderRowTwo } from "./HeaderRowTwo/HeaderRowTwo";

// Context
import { TagsContext } from "../../context/tags";
import { VideosContext } from "../../context/videos";

// CSS
import styles from "./header.module.scss";

const Header = (props) => {
    const {
        history,
        location,
        previousPathname,
        setPreviousPathname,
        setHeaderOffset,
        shouldHideHeader,
    } = props;

    /**
     * useRef
     */

    const headerRef = useRef();

    /**
     * useContext
     */

    const {
        addTag,
        clearTags,
        filters,
        mappedFilters,
        removeTag,
        selectedTags,
    } = useContext(TagsContext);
    const { handleSelectPage, handleToggleSearchMode } =
        useContext(VideosContext);

    /**
     * useEffect
     */

    /**
     * Set header height
     */
    useEffect(() => {
        if (headerRef?.current) {
            setHeaderOffset(headerRef.current.clientHeight);
        }
    }, [headerRef, setHeaderOffset]);

    /**
     * Functionality that should be triggered by a change in the URL
     */
    useEffect(() => {
        if (location.pathname !== previousPathname) {
            if (headerRef?.current) {
                setHeaderOffset(headerRef.current.clientHeight);
            }
            setPreviousPathname(location.pathname);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location]);

    /**
     * Constants
     */

    const isVideoUrl =
        window.location.pathname.includes("video") ||
        window.location.pathname.includes("register/confirmation");

    /**
     * End Hooks
     */

    /**
     *
     * @param {Object} tag  Example: {display_text: "Keynote", tag: "keynote"}
     *
     */
    function handleSelectTag(tag, type) {
        const isAlreadySelected = selectedTags.some(
            (selectedTag) => selectedTag.tag === tag.tag
        );
        isAlreadySelected ? removeTag(tag, type) : addTag(tag, type);
        handleToggleSearchMode(false);
        location.pathname !== "/videos" && history.push("/videos");
    }

    return (
        <div
            className={cx(styles.header, {
                [styles["header--hidden"]]: shouldHideHeader,
            })}
            ref={headerRef}
        >
            <div className={styles.wrapperRelative}>
                <HeaderRowOne {...props} />
                <HeaderRowTwo {...props} clearTags={clearTags} />
                {isVideoUrl && (
                    <HeaderFilters
                        {...props}
                        clearTags={clearTags}
                        handleToggleSearchMode={handleToggleSearchMode}
                    />
                )}
                {isVideoUrl && (
                    <HeaderFilterTags
                        {...props}
                        handleSelectPage={handleSelectPage}
                        handleSelectTag={handleSelectTag}
                        filters={filters}
                        mappedFilters={mappedFilters}
                        selectedTags={selectedTags}
                    />
                )}
            </div>
        </div>
    );
};

export default Header;
